import router from "./../router";
import VueGtag from "vue-gtag";
import Vue from "vue";
Vue.use(
    VueGtag,
    {
        config: { id: "UA-159211201-1" },
        disableScriptLoad: true
    },
    router
);
